/* eslint-disable import/no-extraneous-dependencies */
import Base64 from 'crypto-js/enc-base64';
import hmacSHA256 from 'crypto-js/hmac-sha256';

const confuseDelimiter1 = 'void';
const confuseDelimiter2 = 'string';
const confuseSalt = 'int';

function encodeURIComponentRFC3986(str) {
  return encodeURIComponent(str).replace(
    /[!'()*]/g,
    c => `%${c.charCodeAt(0).toString(16)}`
  );
}

/**
 * Запутываем название заголовка чтобы усложнить поиск по коду
 */
function getCorrectStringName(name) {
  // Signature
  const headerName = Object.values(
    Object.keys(name)
      .sort()
      .reduce((obj, key) => {
        // eslint-disable-next-line no-param-reassign
        obj[key] = name[key];
        return obj;
      }, {})
  ).join('');
  return headerName.charAt(0).toUpperCase() + headerName.slice(1);
}

function bodyParamsToConfuseString(bodyParams) {
  const sortObj = Object.keys(bodyParams)
    .sort()
    .reduce((obj, key) => {
      // eslint-disable-next-line no-param-reassign
      obj[key] = bodyParams[key];
      return obj;
    }, {});
  // console.log(sortObj);
  const result = Object.entries(sortObj)
    .map(([key, value]) => {
      // Если объект то модифицируем в строку 'object'
      let modifyValue =
        typeof value === 'object' && value !== null ? 'object' : value;
      if (modifyValue === null) {
        modifyValue = '';
      }
      return `${key}${confuseDelimiter1}${modifyValue}`;
    })
    .join(confuseDelimiter2);
  // console.log(result);
  return result;
}

/**
 * Генерирует header object с подписью приложения клиента
 */
export function getClientSignatureHeader(
  httpMethod,
  requestUrl,
  bodyParams = {}
) {
  const apiClientKeyHeaderValue = getCorrectStringName({
    e: '7',
    c: 'I',
    g: '1',
    d: 'D',
    f: '9',
    b: 'C',
    a: 'B'
  });
  const apiClientKeyHeaderName = getCorrectStringName({
    b: 'p',
    a: 'a',
    l: 'k',
    e: 'c',
    i: 'n',
    h: 'e',
    f: 'l',
    m: 'e',
    g: 'i',
    j: 't',
    c: 'p',
    n: 'y',
    d: '-',
    k: '-'
  });
  const signatureHeaderName = getCorrectStringName({
    e: 'a',
    h: 'r',
    f: 't',
    a: 's',
    g: 'u',
    i: 'e',
    b: 'i',
    c: 'g',
    d: 'n'
  });
  // console.log(headerName);
  const url = new URL(requestUrl);
  // console.log(requestUrl);
  // console.log(url);
  // console.log(url.pathname);
  const requestPathname = encodeURIComponentRFC3986(url.pathname);
  // console.log(requestPathname);
  const urlSearchParams = url.search
    ? decodeURIComponent(url.search.substring(1))
    : '';
  // console.log(urlSearchParams);

  const allQueryParamsObj = { ...bodyParams };
  urlSearchParams.replace(/([^=&]+)=([^&]*)/g, (m, key, value) => {
    allQueryParamsObj[key] = value;
  });
  const allQueryParamsString = encodeURIComponentRFC3986(
    bodyParamsToConfuseString(allQueryParamsObj)
  );
  const requestData = [httpMethod, requestPathname, allQueryParamsString].join(
    '&'
  );

  const signature = hmacSHA256(
    requestData,
    apiClientKeyHeaderValue + confuseSalt
  );
  return {
    [apiClientKeyHeaderName]: apiClientKeyHeaderValue,
    [signatureHeaderName]: Base64.stringify(signature)
  };
}

export default null;



// WEBPACK FOOTER //
// ./src/mt-react-common/utils/apiClient/clientSignatureBuilder.js